import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { FaRegClone } from "react-icons/fa";
import { CopyToClipboard } from "react-copy-to-clipboard";
import mixpanel from "mixpanel-browser";
import { FiPlusCircle } from "react-icons/fi";
import TextField from "@material-ui/core/TextField";
import SearchIcon from "@material-ui/icons/Search";
import Popover from "@material-ui/core/Popover";
import { FiTrendingUp } from "react-icons/fi";
import { useQueryParam, StringParam } from "use-query-params";
import { addDays } from "date-fns";
import intervalToDuration from "date-fns/intervalToDuration";

import {
  saveCategories,
  loadMenu,
  addCategory as addCategoryAction,
} from "../../Store/Modules/Menu/Actions";
import { api } from "../../Services/Api";
import CategoryPanel from "../../Components/Category";
import RefreshStore from "../../Components/RefreshStore";
import DragAndDrop from "../../Components/DragAndDrop";
import MoreVertMenu from "../../Components/MoreVertMenu";
import EditProductDialog from "../../Components/EditProductDialog";
import OpenDialog from "../../Components/OpenDialog";
import AddNewCategory from "./AddNewCategory";
import ListCategoryTemplates from "./ListCategoryTemplates";
import Loading from "../../Components/Loading";
import AcaiTemplateNotify from "../../Dialogs/AcaiTemplateNotify";
import SearchProductDialog from "../../Dialogs/SearchProducts";
import { mixPanelEvents } from "../../Constants";

import {
  Container,
  ListPanels,
  NewCategory,
  TopActions,
  Info,
  ItemCategoryToReorder,
  ListCategoryToReorder,
  Form,
} from "./style";
import { Row } from "../../Theme";
import {
  Box,
  DialogActions,
  IconButton,
  SvgIcon,
  Typography,
} from "@material-ui/core";

import useSubscription from "../../Utils/useSubscription";

export default function Dashboard(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { remainingDays } = useSubscription();

  const categories = useSelector((state) => state.menu.menu);
  const alias = useSelector((state) => state.store.alias);
  const [reorder, setReorder] = React.useState(false);
  const [openDialogCadProducts, setOpenDialogCadProducts] =
    React.useState(false);
  const [search, setSearch] = React.useState("");
  const [_, setOpenDialog] = useQueryParam("openDialog", StringParam);
  const [openDialogVencimento, setOpenDialogVencimento] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openPopoverAddCategory, setOpenPopoverAddCategory] =
    React.useState(false);
  const [openPopoverListTemplates, setOpenPopoverListTemplates] =
    React.useState(false);

  /*  const [search, setSearch] = React.useState("");
  const lowerSearch = search.toLowerCase();
  const filteredProducts = state.filter(({ itens: products }) =>
    products.includes(lowerSearch)
  ); */

  const handleReorderChange = async (reordedCategories) => {
    try {
      dispatch({ type: "SET_CATEGORIES", categories: reordedCategories });
      await api.put(`menu/reorder-categories`, {
        orderedListId: reordedCategories.map((category) => category._id),
      });
    } catch (err) {
      alert("Não foi possível reordenar.");
    }
  };

  /*function addCategory() {
    const categoryName = prompt("Qual o nome da Categoria?");
    if (!categoryName) return;

    dispatch(addCategoryAction(categoryName));
  }*/

  const handleAddCategory = (ev) => {
    ev.preventDefault();
    dispatch(addCategoryAction(ev.target.nameShow.value));
    setOpenPopoverAddCategory(false);
  };

  const handleClickAddCategory = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopoverListTemplates(true);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
    setOpenPopoverAddCategory(false);
    setOpenPopoverListTemplates(false);
  };

  const handleCloseDialogVencimento = () => {
    setOpenDialogVencimento(false);
  };

  React.useEffect(() => {
    dispatch(loadMenu());
  }, []);

  React.useEffect(() => {
    if (remainingDays <= 5 && remainingDays > 0) {
      setOpenDialogVencimento(true);
    }
  }, [remainingDays]);

  if (!categories) return <Loading />;

  return (
    <>
      <Container {...props}>
        {/* <Info>
      Dica: Em um <strong>Computador</strong> é mais fácil criar ou fazer
      alterações em produtos. =)
    </Info> */}

        <TopActions>
          {categories.length === 0 && <AddNewCategory />}
          {categories.length === 0 && (
            <>
              <Dialog
                maxWidth="sm"
                open={openDialogCadProducts}
                onClose={() => setOpenDialogCadProducts(false)}
              >
                <DialogContent>
                  <Row>
                    Para empresários que estão na correria do dia-a-dia e não
                    tem tempo para cadastrar todos os itens do cardápio nós
                    temos um <strong>Serviço Exclusivo de Cadastro.</strong>
                  </Row>
                  <Row horizontalCenter>
                    <Button
                      onClick={() =>
                        mixpanel.track(mixPanelEvents.CLICK_OFFER_CAD_CARDAPIO)
                      }
                      size="medium"
                      color="primary"
                      variant="outlined"
                      href="https://api.whatsapp.com/send?phone=553498807793&text=Oi%2C%20eu%20quero%20contratar%20o%20servi%C3%A7o%20de%20cadastro%20de%20produtos"
                      target="_blank"
                    >
                      Contratar por apenas R$69,90
                    </Button>
                  </Row>
                </DialogContent>
              </Dialog>
              <Row horizontalCenter>
                <Button
                  style={{ height: "50px" }}
                  size="small"
                  color="secondary"
                  variant="contained"
                  onClick={() => {
                    mixpanel.track(mixPanelEvents.VIEW_OFFER_CAD_CARDAPIO);
                    setOpenDialogCadProducts(true);
                  }}
                >
                  Serviço de Cadastro
                </Button>
              </Row>
            </>
          )}
          {categories.length > 0 && (
            <>
              <Hidden xsDown={true}>
                {!reorder && (
                  <Button
                    size="small"
                    variant="contained"
                    onClick={handleClickAddCategory}
                  >
                    <FiPlusCircle
                      style={{ fontSize: "20px", marginRight: "5px" }}
                    />{" "}
                    Adicionar Categoria
                  </Button>
                )}

                {!reorder && (
                  <>
                    <Button size="small" onClick={() => setReorder(!reorder)}>
                      Reordenar Categorias
                    </Button>
                    <IconButton onClick={() => setOpenDialog("search-product")}>
                      <SearchIcon color="action" />
                    </IconButton>
                  </>
                )}
              </Hidden>
              <Hidden smUp={true}>
                {alias && (
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Box>
                      <a target="_blank" href={`https://${alias}`}>
                        Acessar Cardápio{" "}
                      </a>
                      <CopyToClipboard
                        text={`https://${alias}`}
                        onCopy={() => {
                          mixpanel.track(
                            mixPanelEvents.COPY_LINK_FROM_DASHBOARD
                          );
                          alert("Copiado");
                        }}
                      >
                        <Button>
                          <FaRegClone size="18px" />
                        </Button>
                      </CopyToClipboard>
                    </Box>
                    <Box paddingTop={1} paddingRight={2} paddingLeft={0}>
                      <IconButton
                        onClick={() => setOpenDialog("search-product")}
                      >
                        <SearchIcon color="action" size="18px" />
                      </IconButton>
                      <MoreVertMenu>
                        <MenuItem onClick={handleClickAddCategory}>
                          Adicionar Categoria
                        </MenuItem>
                        <MenuItem onClick={() => setReorder(!reorder)}>
                          Reordenar Categorias
                        </MenuItem>
                      </MoreVertMenu>
                    </Box>
                  </Box>
                )}
              </Hidden>
            </>
          )}
        </TopActions>
        <div>
          {reorder && (
            <>
              <u
                style={{ cursor: "pointer" }}
                onClick={() => setReorder(false)}
              >
                Fechar modo de reordenar categorias
              </u>
              <DragAndDrop
                dragStyle={{
                  position: "absolute",
                  zIndex: "1",
                  left: "-20px",
                  top: "30px",
                }}
                list={categories}
                onUpdateList={handleReorderChange}
                ContainerToRender={ListCategoryToReorder}
                ItemToRender={({ data: cat }) => (
                  <ItemCategoryToReorder>{cat.nameShow}</ItemCategoryToReorder>
                )}
              />
            </>
          )}
          {!reorder && (
            <ListPanels>
              {categories.map((cat) => (
                <CategoryPanel key={cat._id} id={cat._id} />
              ))}
            </ListPanels>
          )}
        </div>
        <Popover
          open={openPopoverAddCategory}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <DialogContent>
            <Form onSubmit={handleAddCategory}>
              <TextField
                label="Nome da categoria"
                name="nameShow"
                required
                autoFocus
                variant="outlined"
                size="small"
                autoComplete="off"
              />

              <Button type="submit" variant="contained" color="primary">
                Salvar
              </Button>
            </Form>
            <Button
              onClick={handleClosePopover}
              color="default"
              style={{ float: "right" }}
            >
              Fechar
            </Button>
          </DialogContent>
        </Popover>
        <Popover
          open={openPopoverListTemplates}
          anchorEl={anchorEl}
          onClose={handleClosePopover}
          draggable
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <DialogContent>
            <ListCategoryTemplates
              onClose={handleClosePopover}
              onClickNew={() => {
                setOpenPopoverListTemplates(false);
                setOpenPopoverAddCategory(true);
              }}
            />
          </DialogContent>
        </Popover>
      </Container>
      <EditProductDialog />
      <AcaiTemplateNotify />
      <SearchProductDialog />
      <Dialog open={openDialogVencimento} onClose={handleCloseDialogVencimento}>
        <DialogContent>
          <Typography>
            Você tem <strong>{remainingDays} dias </strong> para renovar a sua
            assinatura!
          </Typography>
          <DialogActions>
            <Button onClick={handleCloseDialogVencimento} variant="text">
              Fechar
            </Button>
            <Button
              onClick={() => history.push("/plans")}
              variant="contained"
              color="primary"
            >
              Assinar Agora
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
}
